import { SET_CUSTOMERS_VERSIONS_WS, SET_CUSTOMERS_VERSIONS } from './chunk-S5MTJL4K.mjs';

// src/state/customers/versions/actions.ts
var setCustomersVersions = (payload, isWebSocket = false) => ({
  type: isWebSocket ? SET_CUSTOMERS_VERSIONS_WS : SET_CUSTOMERS_VERSIONS,
  payload
});

export { setCustomersVersions };
